import { useApp } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { StatusBadge } from "@/components/StatusBadge";
import { Clock, XCircle, Lock } from "lucide-react";

export default function StatusWall() {
  const { t, accessStatus, user } = useApp();
  const map = {
    pending: { title: t("pending_title"), desc: t("pending_desc"), icon: Clock, badge: "pending" },
    rejected: { title: t("rejected_title"), desc: t("rejected_desc"), icon: XCircle, badge: "rejected" },
    blocked: { title: t("blocked_title"), desc: t("blocked_desc"), icon: Lock, badge: "blocked" },
  };
  const s = map[accessStatus] || map.pending;
  const Icon = s.icon;
  return (
    <div className="min-h-screen bg-[#0d0d0d] bg-grain">
      <Header />
      <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="status-wall">
        <Icon className="w-16 h-16 text-[#D21F2A] mx-auto mb-6" />
        <h1 className="font-serif text-3xl text-[#FFFFFF] mb-3">{s.title}</h1>
        <p className="text-[#C9CDD3] leading-relaxed mb-6">{s.desc}</p>
        <div className="flex justify-center">
          <StatusBadge status={s.badge} label={t(`status_${accessStatus === "pending" ? "in_progress" : "not_started"}`) && accessStatus} testid="access-status-badge" />
        </div>
        {user && <p className="mt-8 text-xs text-[#9AA0A6]">{user.email}</p>}
      </div>
    </div>
  );
}
